<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select
              v-model="searchInfo.whCode"
              placeholder="请选择"
              clearable="clearable"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.whId"
                :label="item.whCode + '-' + item.whName"
                :value="item.whCode"
                >{{ item.whCode }}-{{ item.whName }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="订单编号" class="EL-Form-Item">
            <el-input
              v-model="searchInfo.orderCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="质检编号" class="EL-Form-Item">
            <el-input
              v-model="searchInfo.sqCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              placeholder="请输入"
              v-model="searchInfo.matCode"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料批次" class="EL-Form-Item">
            <el-input
              placeholder="请输入"
              v-model="searchInfo.batchNo"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getMainData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="箱号" class="EL-Form-Item">
            <el-input
              placeholder="请输入"
              v-model="searchInfo.boxCode"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker
              v-model="searchInfo.date[0]"
              @change="saveSearch()"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker
              v-model="searchInfo.date[1]"
              @change="saveSearch()"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="质量未检报表（默认近三个月的数据）">
        <el-button
          v-authority="'BACK_MENU7_M13_B1'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getMainData"
        :data="mainData"
        pagination
        :nowPage.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total.sync="pagination.total"
      >
        <el-table-column label="通道编号" align="center" prop="whCode">
        </el-table-column>
        <!-- <el-table-column label="质检单号" align="center" prop="sqCode">
        </el-table-column> -->
        <el-table-column label="订单编号" align="center" prop="orderCode">
        </el-table-column>
        <el-table-column label="物料编号" align="center" prop="matCode">
        </el-table-column>
        <el-table-column label="物料描述" align="center" prop="matName">
        </el-table-column>
        <el-table-column label="批次号" align="center" prop="batchNo">
        </el-table-column>
        <el-table-column label="包装箱号" align="center" prop="boxCode">
        </el-table-column>
        <el-table-column label="数量" align="center" prop="matQuan">
        </el-table-column>
        <!-- <el-table-column label="不合格数量" align="center" prop="badNumber">
        </el-table-column>
        <el-table-column label="破坏数量" align="center" prop="destroyNumber">
        </el-table-column> -->
        <el-table-column label="库位" align="center" prop="laCode">
        </el-table-column>
        <!-- <el-table-column label="合格库位" align="center" prop="laGoodCode">
        </el-table-column> -->
        <el-table-column label="钢号" align="center" prop="steelGrade">
        </el-table-column>
        <el-table-column label="热处理批号" align="center" prop="heatNumber">
        </el-table-column>
        <el-table-column label="质检结果" align="center" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.sqResult == 'WAIT'">待检</span>
            <span v-if="scope.row.sqResult == 'OK'">合格</span>
            <span v-if="scope.row.sqResult == 'PICK'">挑选</span>
            <span v-if="scope.row.sqResult == 'COMPLETE'">挑选完成</span>
            <span v-if="scope.row.sqResult == 'NOK'">不合格</span>
            <span v-if="scope.row.sqResult == 'CLOSE'">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="收货人" align="center" prop="person">
        </el-table-column>
        <el-table-column label="报检时间" align="center" prop="createTime">
        </el-table-column>
        <el-table-column label="超期天数" align="center" prop="exceedLimitDate">
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="supplier">
        </el-table-column>
        <el-table-column label="备注" align="center" prop="remark">
        </el-table-column>
      </h-table>
    </box>
  </div>
</template>
<script>
export default {
  name: "stockQualityWait",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      searchInfo: {
        whCode: "",
        orderCode: "",
				sqCode: "",
        matCode: "",
        batchNo: "",
        boxCode: "",
        fcCode: localStorage.getItem("fcCode") || "",
        date: [],
      },
      warehouseList: [],
      taskTab: "0",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {
    searchInfo: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getMainData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.searchInfo.date[0]) {
            return time.getTime() < new Date(_this.searchInfo.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.searchInfo.date[1]) {
            return time.getTime() > new Date(_this.searchInfo.date[1]);
          }
        },
      };
    },
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getMainData();
      }, 1000);
    },

    /**
     * 获取通道数据
     */
    getWarehouse() {
      this.$http
        .request({
          url: "/api/warehouse/getWarehouse",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
            whCode: "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.warehouseList = resp.data.list || [];
          }
        })
        .catch((error) => {
          this.loading++;
        });
    },
    //获取数据
    getMainData() {
      this.$http
        .request({
          url: "/api/order/getStockQualityWait",
          method: "GET",
          params: {
            fcCode: this.searchInfo.fcCode || null,
            whCode: this.searchInfo.whCode || null,
            orderCode: this.searchInfo.orderCode || null,
						sqCode: this.searchInfo.sqCode || null,
            matCode: this.searchInfo.matCode || null,
            batchNo: this.searchInfo.batchNo || null,
            boxCode: this.searchInfo.boxCode || null,
						result: 'WAIT',
            beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
            endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainData = res.data.list || [];
            this.pagination.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
      this.searchInfo = {
        whCode: "",
        orderCode: "",
        matCode: "",
        batchNo: "",
        fcCode: localStorage.getItem("fcCode") || null,
        date: [],
      };
      this.getMainData();
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.searchInfo.fcCode || null,
        whCode: this.searchInfo.whCode || null,
        orderCode: this.searchInfo.orderCode || null,
				sqCode: this.searchInfo.sqCode || null,
        matCode: this.searchInfo.matCode || null,
        batchNo: this.searchInfo.batchNo || null,
        boxCode: this.searchInfo.boxCode || null,
				result: 'WAIT',
        beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
        endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/order/getStockQualityWait",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
				list.forEach(function(c) {
					if (c.sqResult == 'WAIT') {
            c['sqResult'] = '待检'
          } else if (c.sqResult == 'OK') {
            c['sqResult'] = '合格'
          } else if (c.sqResult == 'PICK') {
            c['sqResult'] = '挑选'
          } else if (c.sqResult == 'NOK') {
            c['sqResult'] = '不合格'
          } else if (c.sqResult == 'COMPLETE') {
            c['sqResult'] = '挑选完成'
          } else if (c.sqResult == 'CLOSE') {
						c['sqResult'] = '关闭'
					}
				});
        const tHeader = [
          "通道编号",
          "订单编号",
          "物料编号",
          "物料描述",
          "批次号",
          "包装箱号",
          "数量",
          "库位",
          "钢号",
          "热处理批号",
          "质检结果",
          "收货人",
          "报检时间",
          "超期天数",
          "供应商",
          "备注",
        ];

        const filterVal = [
          "whCode",
          "orderCode",
          "matCode",
          "matName",
          "batchNo",
          "boxCode",
          "matQuan",
          "laCode",
          "steelGrade",
					"heatNumber",
					"sqResult",
          "person",
          "createTime",
          "exceedLimitDate",
          "supplier",
          "remark",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "质量未检报表",
        });
        this.logContent = "导出";
        this.logRemarks = "stock_quality：导出质量未检报表";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "质量未检报表",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
  activated() {
    /* 获取首页的数据 */
    this.getWarehouse();
    this.getMainData();
  },
};
</script>

<style scoped>
</style>